export default "__VITE_ASSET__DigLryPK__"